import "./App.css";
import { Route, Routes } from "react-router-dom";
import Login from "./components/pages/Login";
import Home from "./components/pages/Home";
import { LoginUserProvider } from "./components/provider/LoginUserProvider";
import NotFound from "./components/pages/NotFound";
import RegisterFailed from "./components/pages/RegisterFailed";
import RegisterSucceeded from "./components/pages/RegisterSucceeded";
import Register from "./components/pages/Register";
import LoginFailed from "./components/pages/LoginFailed";
import { useEffect, useState } from "react";
import { format } from "date-fns";
import AppLayout from "./components/layout/AppLayout";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { theme } from "./theme/theme";
import Report from "./components/pages/Report";
import axios from "axios";
import WorkoutProvider from "./components/provider/WorkoutProvider";

function App() {
  const [currentMonth, setCurrentMonth] = useState(new Date());

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <LoginUserProvider>
        <WorkoutProvider>
          <Routes>
            <Route path="/" element={<AppLayout />}>
              <Route
                index
                element={
                  <Home
                    setCurrentMonth={setCurrentMonth}
                    currentMonth={currentMonth}
                    // onSaveTransaction={handleSaveTransaction}
                  />
                }
              />
              <Route
                path="/report"
                element={
                  <Report
                    currentMonth={currentMonth}
                    setCurrentMonth={setCurrentMonth}
                  />
                }
              />
              <Route path="/login" element={<Login />} />
              <Route path="/loginfailed" element={<LoginFailed />} />
              <Route path="/register" element={<Register />} />
              <Route
                path="/registersucceeded"
                element={<RegisterSucceeded />}
              />
              <Route path="/registerfailed" element={<RegisterFailed />} />
              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
        </WorkoutProvider>
      </LoginUserProvider>
    </ThemeProvider>
  );
}

export default App;
